import { useTranslation } from "react-i18next";
import { Badge } from "~/components/ui/badge";
import { BooksTableDetailRowSectionLabel } from "./books-table-detail-row-section-label";

export const BooksTableDetailRowGenreBadges = ({
  genres,
}: {
  genres: string[];
}) => {
  const { t } = useTranslation(["components"]);

  if (genres.length === 0) return null;

  return (
    <div className="flex flex-col gap-1.5">
      <BooksTableDetailRowSectionLabel
        label={t("components:booksTable.detail.genre")}
        count={genres.length}
      />
      <div className="flex items-center gap-1.5 flex-wrap">
        {genres.map((genre) => (
          <Badge
            key={genre}
            variant="outline"
            className="border-secondary-200 bg-white px-2 py-0.5 min-w-0 text-secondary-600"
          >
            {genre}
          </Badge>
        ))}
      </div>
    </div>
  );
};
